import apiSlice from './apiSlice';

export interface StakeItem {
  label: string;
  value: number;
}

export interface GetStakeSetResponse {
  success: boolean;
  message: string;
  stakeSet: StakeItem[];
}

export interface UpdateStakeSetPayload {
  data: StakeItem[];
}

export interface UpdateStakeSetResponse {
  success: boolean;
  message: string;
}

export const stakeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStakeSet: builder.query<GetStakeSetResponse, void>({
      query: () => ({
        url: '/stakeset',
        method: 'GET',
        params: { t: Date.now() },
        requiresAuth: true,
      }),
      providesTags: ['StakeSet'],
    }),

    updateStakeSet: builder.mutation<UpdateStakeSetResponse, UpdateStakeSetPayload>({
      query: (body) => ({
        url: '/stakeset',
        method: 'PUT',
        body,
        requiresAuth: true,
      }),
      invalidatesTags: ['StakeSet'],
    }),
  }),
});

export const { useGetStakeSetQuery, useUpdateStakeSetMutation } = stakeApi;
